// ActionButton.tsx
import React from "react";

interface UploadButtonProps {
    onAction: () => void;
    isEnabled: boolean;
    title: string;
}

const ActionButton: React.FC<UploadButtonProps> = ({ onAction, isEnabled, title }) => (
    <div className="action-paint-upload-btn-container">
        <button
            className={`action-button-primary action-upload-btn ${isEnabled ? 'enabled' : 'disabled'}`}
            onClick={onAction}
            disabled={!isEnabled}
        >
            {title}
        </button>
    </div>
);

export default ActionButton;

// Add CSS styles directly in this file using a template literal

const styles = `
/* Define Primary and Secondary colors */
:root {
    --primary-color: #007bff; /* Blue */
    --secondary-color: #e6f7ff; /* Light Blue */
}

/* Container styling */
.action-paint-upload-btn-container {
    display: flex;
    justify-content: center; /* Centering the button horizontally */
    align-items: center; /* Centering the button vertically if needed */
    margin: 0px 0; /* Add space around the button */
}

/* Default button styles */
.action-button-primary {
    padding: 10px 20px;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
    border: none;
    border-radius: 5px;
    transition: background-color 0.3s ease, transform 0.2s ease;
    width: max-content;
}

/* Hover and focus states */
.action-button-primary:hover {
    background-color: var(--primary-color);
    transform: scale(1.05); /* Slightly enlarges the button on hover */
}

.action-button-primary:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(38, 129, 255, 0.6); /* Adds a glow effect */
}

/* Disabled button styles */
.action-button-primary.disabled {
    background-color: #ccc;
    color: #666;
    cursor: not-allowed;
}

.action-button-primary.enabled {
    background-color: var(--primary-color); /* Primary color for enabled state */
    color: white;
}
`;

// Inject styles into the page
const styleTag = document.createElement('style');
styleTag.innerHTML = styles;
document.head.appendChild(styleTag);
